import useDi from '../useDi'

import Token from '@/di/di.token'

export default function useWorkspaceService() {
  const { container } = useDi()
  const service = container.get(Token.SCHEDULER_SERVICE)
  return { service }
}
